import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Refresh as RefreshIcon, Add as AddIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { getManagements } from '../../data/Managements/actions';

class Management extends PureComponent {
    static propTypes = {
        getManagements: PropTypes.func.isRequired,
        Managements: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshManagements();
    }

    refreshManagements = () => {
        const { getManagements } = this.props;
        this.setState({ loading: true });
        return getManagements()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `management/detail/${rowData.managementId}` });
    };
    navigateToAdd = () => {
        const { history } = this.props;
        return history.push({ pathname: 'management/add' });
    };

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate(`generic.management.table.globalAction.refresh.tooltip`),
                    onClick: this.refreshManagements
                }
            ]
        };
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('managementAdd')) {
            actions.toolbar.push({
                icon: AddIcon,
                tooltip: Translator.translate(`generic.management.table.globalAction.add.tooltip`),
                onClick: this.navigateToAdd
            });
        }
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('managementDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`)
            });
        }
        return actions;
    });

    renderData = memoizeOne(Managements => {
        let result = [];
        Managements.map((Management, ManagementId) => {
            result.push({
                managementId: parseInt(ManagementId),
                title: Management.get('title'),
                label: Management.get('libelle'),
                buildingType: Management.get('buildingType'),
                weatherCity: Management.get('weatherCity'),
                address: Management.get('address'),
                city: Management.get('city'),
                postalCode: Management.get('postalCode')
            });
        });
        return result;
    });

    renderColumns = memoizeOne(profile => {
        const { history } = this.props;

        return [
            {
                title: Translator.translate('general.table.column.id'),
                name: 'managementId',
                defaultSort: 'desc',
                fixedLeft: true
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('managementDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.brand'),
                name: 'title',
            },
            {
                title: Translator.translate('general.table.column.type'),
                name: 'buildingType',
                render: (row, data, value) => {
                    if (!value) return null;
                    return Translator.translate(`generic.management.table.${value}`);
                }
            },
            {
                title: Translator.translate('general.table.column.weatherCity'),
                name: 'weatherCity'
            },
            {
                title: Translator.translate('general.table.column.address'),
                name: 'address'
            },
            {
                title: Translator.translate('general.table.column.city'),
                name: 'city'
            },
            {
                title: Translator.translate('general.table.column.postalCode'),
                name: 'postalCode'
            }
        ];
    });

    render() {
        const { loading } = this.state;
        const { Managements, profile, history } = this.props;
        return (
            <FHETable
                idTable="managementList"
                columns={this.renderColumns(profile)}
                data={this.renderData(Managements)}
                actions={this.renderActions(profile)}
                title={Translator.translate(`generic.management.table.title`)}
                emptyDataSourceMessage={Translator.translate(`generic.management.table.body.emptyDataSourceMessage`)}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    return {
        profile: state.data.user,
        Managements: state.environments[history.environment].data.Managements.get('list'),
        initialized: state.environments[history.environment].data.Managements.get('initialized')
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/Management/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { getManagements }), dispatch)
        )(Management)
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Management/index.js